import { render, staticRenderFns } from "./SM-Permission-Selectbox.vue?vue&type=template&id=725bfb8c"
import script from "./SM-Permission-Selectbox.vue?vue&type=script&lang=js"
export * from "./SM-Permission-Selectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports